import React from 'react';
import {CELECTIALS_MELEE_DAMAGE_DICE_COUNT} from "../../../../configs/factions/celectials";
import {MELEE_COUNTED_DAMAGE_DICE_COUNT} from "../../../../configs/damage";
import {MaskedIcon} from "../../../coloredIcons/MaskedIcon/MaskedIcon";

const FactionCelectialsDescription = () => {
  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;

  // Иконка полета — белый силуэт: на светлой карточке перекрашиваем маской
  const flight = <MaskedIcon
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/fly.png'}
    alt={'Полет'}
    title={'Полет'}
  />;

  const dice = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/dice.png'}
    alt={'Кость урона'}
    title={'Кость урона'}
  />;

  const melee = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/barracks red.png'}
    alt={'Ближний бой'}
    title={'Ближний бой'}
  />;

  const supply = <img
    className={'policy-description-icon policy-description-icon-margin-right-left'}
    src={'/img/icons/supply.png'}
    alt={'Дополнительное снабжение'}
    title={'Дополнительное снабжение'}
  />;

  return (
    <>
      <div className="policy-description_line">
        Все {unit} летают {flight}.
      </div>
      <div className="policy-description_line policy-description_line-margin-top">
        В {melee} бросают {CELECTIALS_MELEE_DAMAGE_DICE_COUNT}{dice} вместо 2,
      </div>
      <div className="policy-description_line">
        в урон идут {MELEE_COUNTED_DAMAGE_DICE_COUNT} лучшие.
      </div>
      <div className="policy-description_line">
        За {supply} можно перебросить любые из них.
      </div>
    </>
  );
};

export default FactionCelectialsDescription;
